package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository

class CancelAnnouncementUseCase(
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        triggeredBy: String,
        targetParticipants: List<String>,
        announcementEventId: String
    ): Result<Unit> = gameEventRepository.createEvent(
        tableId = tableId,
        type = EventType.ANNOUNCEMENT_CANCELLED,
        triggeredBy = triggeredBy,
        targetParticipants = targetParticipants,
        content = EventContent.AnnouncementCancelled(announcementEventId = announcementEventId)
    ).map { }
}
